// Version : 0.0.1
// Author : VISHNU
// LastEdit : KARTHEESWARAN
// MODFIED DATE:31-07-2025
import insuranceCompanyActionTypes from './insurance-company.types';

/** ***************** ADD INSURANCE COMPANY DETAILS START *********************** */
export const addInsuranceCompanyDetailsStart = (addData: any) => ({
	type: insuranceCompanyActionTypes.ADD_INSURANCE_COMPANY_DETAILS_START,
	payload: addData,
});

export const addInsuranceCompanyDetailsSuccess = (successData: any) => ({
	type: insuranceCompanyActionTypes.ADD_INSURANCE_COMPANY_DETAILS_SUCCESS,
	payload: successData,
});

export const addInsuranceCompanyDetailsFailure = (failureData: any) => ({
	type: insuranceCompanyActionTypes.ADD_INSURANCE_COMPANY_DETAILS_FAILURE,
	payload: failureData,
});

export const addInsuranceCompanyDetailsResponseResetStart = () => ({
	type: insuranceCompanyActionTypes.ADD_INSURANCE_COMPANY_DETAILS_RESPONSE_RESET,
});

export const addInsuranceCompanyDetailsResponseChanged = () => ({
	type: insuranceCompanyActionTypes.ADD_INSURANCE_COMPANY_DETAILS_RESPONSE_CHANGED,
});
/** ***************** ADD INSURANCE COMPANY DETAILS END *********************** */

/*************** START UPDATE INSURANCE COMPANY DETAILS ******************/
export const updateInsuranceCompanyDetailsStart = (updateData: any) => ({
	type: insuranceCompanyActionTypes.UPDATE_INSURANCE_COMPANY_DETAILS_START,
	payload: updateData,
});

export const updateInsuranceCompanyDetailsSuccess = (successData: any) => ({
	type: insuranceCompanyActionTypes.UPDATE_INSURANCE_COMPANY_DETAILS_SUCCESS,
	payload: successData,
});

export const updateInsuranceCompanyDetailsFailure = (failureData: any) => ({
	type: insuranceCompanyActionTypes.UPDATE_INSURANCE_COMPANY_DETAILS_FAILURE,
	payload: failureData,
});

export const updateInsuranceCompanyDetailsResponseResetStart = () => ({
	type: insuranceCompanyActionTypes.UPDATE_INSURANCE_COMPANY_DETAILS_RESPONSE_RESET,
});

export const updateInsuranceCompanyDetailsResponseChanged = () => ({
	type: insuranceCompanyActionTypes.UPDATE_INSURANCE_COMPANY_DETAILS_RESPONSE_CHANGED,
});
/*************** END UPDATE INSURANCE COMPANY DETAILS ******************/

/*************** START GET INSURANCE COMPANY LIST ******************/
export const getInsuranceCompanyListStart = (getData: any) => ({
	type: insuranceCompanyActionTypes.GET_INSURANCE_COMPANY_LIST_START,
	payload: getData,
});

export const getInsuranceCompanyListSuccess = (successData: any) => ({
	type: insuranceCompanyActionTypes.GET_INSURANCE_COMPANY_LIST_SUCCESS,
	payload: successData,
});

export const getInsuranceCompanyListFailure = (failureData: any) => ({
	type: insuranceCompanyActionTypes.GET_INSURANCE_COMPANY_LIST_FAILURE,
	payload: failureData,
});

export const getInsuranceCompanyListResponseResetStart = () => ({
	type: insuranceCompanyActionTypes.GET_INSURANCE_COMPANY_LIST_RESPONSE_RESET,
});

export const getInsuranceCompanyListResponseChanged = () => ({
	type: insuranceCompanyActionTypes.GET_INSURANCE_COMPANY_LIST_RESPONSE_CHANGED,
});
/*************** END GET INSURANCE COMPANY LIST ******************/

/*************** START FETCH INSURANCE COMPANY DETAILS ******************/
export const fetchInsuranceCompanyDetailsStart = (fetchData: any) => ({
	type: insuranceCompanyActionTypes.FETCH_INSURANCE_COMPANY_DETAILS_START,
	payload: fetchData,
});

export const fetchInsuranceCompanyDetailsSuccess = (successData: any) => ({
	type: insuranceCompanyActionTypes.FETCH_INSURANCE_COMPANY_DETAILS_SUCCESS,
	payload: successData,
});

export const fetchInsuranceCompanyDetailsFailure = (failureData: any) => ({
	type: insuranceCompanyActionTypes.FETCH_INSURANCE_COMPANY_DETAILS_FAILURE,
	payload: failureData,
});

export const fetchInsuranceCompanyDetailsResponseResetStart = () => ({
	type: insuranceCompanyActionTypes.FETCH_INSURANCE_COMPANY_DETAILS_RESPONSE_RESET,
});

export const fetchInsuranceCompanyDetailsResponseChanged = () => ({
	type: insuranceCompanyActionTypes.FETCH_INSURANCE_COMPANY_DETAILS_RESPONSE_CHANGED,
});
/*************** END FETCH INSURANCE COMPANY DETAILS ******************/

/** ***************** DELETE INSURANCE COMPANY DETAILS START *********************** */
export const deleteInsuranceCompanyDetailsStart = (deleteData: any) => ({
	type: insuranceCompanyActionTypes.DELETE_INSURANCE_COMPANY_DETAILS_START,
	payload: deleteData,
});

export const deleteInsuranceCompanyDetailsSuccess = (successData: any) => ({
	type: insuranceCompanyActionTypes.DELETE_INSURANCE_COMPANY_DETAILS_SUCCESS,
	payload: successData,
});

export const deleteInsuranceCompanyDetailsFailure = (failureData: any) => ({
	type: insuranceCompanyActionTypes.DELETE_INSURANCE_COMPANY_DETAILS_FAILURE,
	payload: failureData,
});

export const deleteInsuranceCompanyDetailsResponseResetStart = () => ({
	type: insuranceCompanyActionTypes.DELETE_INSURANCE_COMPANY_DETAILS_RESPONSE_RESET,
});

export const deleteInsuranceCompanyDetailsResponseChanged = () => ({
	type: insuranceCompanyActionTypes.DELETE_INSURANCE_COMPANY_DETAILS_RESPONSE_CHANGED,
});

/** ***************** DELETE INSURANCE COMPANY DETAILS END *********************** */

/** ***************** FETCH ALL INSURANCE COMPANY START *********************** */
export const fetchAllInsuranceCompanyStart = (fetchInsuranceCompanys: any) => ({
	type: insuranceCompanyActionTypes.FETCH_ALL_INSURANCE_COMPANY_START,
	payload: fetchInsuranceCompanys,
});

export const fetchAllInsuranceCompanySuccess = (successData: any) => ({
	type: insuranceCompanyActionTypes.FETCH_ALL_INSURANCE_COMPANY_SUCCESS,
	payload: successData,
});

export const fetchAllInsuranceCompanyFailure = (failureData: any) => ({
	type: insuranceCompanyActionTypes.FETCH_ALL_INSURANCE_COMPANY_FAILURE,
	payload: failureData,
});

export const fetchAllInsuranceCompanyResponseResetStart = () => ({
	type: insuranceCompanyActionTypes.FETCH_ALL_INSURANCE_COMPANY_RESPONSE_RESET,
});

export const fetchAllInsuranceCompanyResponseChanged = () => ({
	type: insuranceCompanyActionTypes.FETCH_ALL_INSURANCE_COMPANY_RESPONSE_CHANGED,
});
/** ***************** FETCH ALL INSURANCE COMPANY END *********************** */
